module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afore35-ba3dec9c7f9f0caca70a82ce877f54cf.jpg";